var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ai-component-body"},[_c('p',{staticClass:"ai-text"},[_vm._v(_vm._s(_vm.card.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }